import React from "react";

import "./style.css";

const services = [
  {
    title: "Development",
    description:
      "Our development skillsets include HTML, CSS, Javascript, PHP and MySQL.",
  },
  {
    title: "UI/UX Design",
    description:
      "Whether your look for a professional website or a new app, we can design a structured, user friendly interface.",
  },
  {
    title: "Digital Strategy",
    description:
      "Let us market your website, run pay-per-click campaigns, develop valuable content, and a social media plan that is cost-efficient.",
  },
  {
    title: "SEO & PPC",
    description:
      "Let us develop your Pay Per Click Strategy together with the Search Engine Optimization.",
  },
  {
    title: "Automation",
    description:
      "Let us integrate a cutting-edge automation techniques with your business.",
  },
  {
    title: "Coding classes for Youth",
    description:
      "We offer a wide range of coding classes for children age 7 to 12. Our firm belief lies in preparing the Youth for challenges of tomorrow.",
  },
];

function Services() {
  return (
    <div className="App">
      {/* <header className="App-header container-fluid"> */}
        <h1 className="display-4">Welcome to</h1>
        <br></br>
        <h1
          style={{ backgroundColor: "black", color: "white" }}
          className="font-weight-bold p-4"
        >
        Services We Offer
        </h1>
        <br></br>
        <h1 className="display-4">
          Our Team goes Above and Beyond in helping you achieve your goals
        </h1>
      {/* </header> */}

      {services.map((data) => (
        <div class="flip-box">
          <div class="flip-box-inner">
            <div class="flip-box-front">
              <h2>{data.title}</h2>
            </div>
            <div class="flip-box-back">
              <h2>{data.description}</h2>
            </div>
          </div>
        </div>
      ))}

      <br></br>
      <br></br>
      <p className="lead mx-lg-5 font-weight-bold p-4">
        Over the many years of studying the fine art of Web Development we have
        come to conclusion that creating the mere website isn't enough. What
        motivates us are three things: Envolving our clients fully in the
        process of creating a new website, leading by example and giving back to
        community by fostering the Coding classes among the Youth.
      </p>
    </div>
  );
}

export default Services;
